export default "__VITE_ASSET__70116063__"